import { ApiResult } from 'src/Libs/api'

export const preserveExpectedUnavailableResult = async <T>(query: () => Promise<ApiResult<T, boolean>>): Promise<ApiResult<T, boolean>> => {
  const result = await query()
  if (result.hasErrors && result.error !== true) throw new Error('Failed to fetch settings')

  // A plain object keeps expected unavailable results as data; usePortalQueries unwraps ApiResult instances.
  return { value: result.value, hasErrors: result.hasErrors, error: result.error }
}
